import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "file-upload-content" }
const _hoisted_2 = { class: "file-upload-progress" }
const _hoisted_3 = { class: "file-upload__progress-bar" }
const _hoisted_4 = ["aria-valuenow", "aria-label"]
const _hoisted_5 = { class: "file-upload__progress-info" }
const _hoisted_6 = { class: "file-upload__progress-percent" }
const _hoisted_7 = { class: "file-upload__progress-status" }
const _hoisted_8 = {
  key: 0,
  class: "file-upload__progress-icon file-upload__progress-icon--spin",
  viewBox: "0 0 24 24"
}
const _hoisted_9 = {
  key: 1,
  class: "file-upload__progress-icon file-upload__progress-icon--success",
  viewBox: "0 0 24 24"
}
const _hoisted_10 = {
  key: 0,
  class: "file-upload__file-info"
}
const _hoisted_11 = { class: "file-upload__file-size" }
const _hoisted_12 = {
  key: 0,
  class: "file-upload__upload-speed"
}

import { useI18n } from 'vue-i18n';
import AppModal from '../../base/Modal.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'FileUploadModal',
  props: {
    progress: {},
    fileName: {},
    fileSize: {},
    uploadSpeed: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

/// <reference types="vue" />
// @ts-ignore
const props = __props;

const emit = __emit;

const { t } = useI18n();

const formatFileSize = (bytes?: number): string => {
  if (!bytes) return '';

  const units = ['B', 'KB', 'MB', 'GB'];
  let size = bytes;
  let unitIndex = 0;

  while (size >= 1024 && unitIndex < units.length - 1) {
    size = size / 1024;
    unitIndex++;
  }

  return `${size.toFixed(1)} ${units[unitIndex]}`;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppModal, {
    show: true,
    onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
    title: _ctx.$t('documents.uploadingFile'),
    subtitle: _ctx.fileName || 'Processing your file...',
    icon: "upload",
    size: "medium",
    closable: false,
    "overlay-click-close": false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: _normalizeClass(["file-upload__progress-fill", { 'file-upload__progress-fill--complete': _ctx.progress >= 100 }]),
              style: _normalizeStyle({ width: `${_ctx.progress}%` }),
              role: "progressbar",
              "aria-valuenow": _ctx.progress,
              "aria-valuemin": "0",
              "aria-valuemax": "100",
              "aria-label": `Upload progress: ${_ctx.progress}%`
            }, null, 14, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.progress) + "%", 1),
            _createElementVNode("div", _hoisted_7, [
              (_ctx.progress < 100)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_8, [...(_cache[1] || (_cache[1] = [
                    _createElementVNode("path", {
                      fill: "currentColor",
                      d: "M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z"
                    }, null, -1)
                  ]))]))
                : (_openBlock(), _createElementBlock("svg", _hoisted_9, [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("path", {
                      fill: "currentColor",
                      d: "M9,20.42L2.79,14.21L5.62,11.38L9,14.77L18.88,4.88L21.71,7.71L9,20.42Z"
                    }, null, -1)
                  ]))])),
              _createTextVNode(" " + _toDisplayString(_ctx.progress < 100 ? _ctx.$t('documents.uploading') : _ctx.$t('documents.uploadComplete')), 1)
            ])
          ]),
          (_ctx.fileSize)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(formatFileSize(_ctx.fileSize)), 1),
                (_ctx.uploadSpeed)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.uploadSpeed) + "/s ", 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "subtitle"]))
}
}

})